export const djangoUrls = {
  hr_test: "/hr",
  admin_test: "/admin",
  client_test: "/clients",
  website_test: "/website-builder?templateId=1001",
  ping_test: "/ping",
  classroom: "/classroom",
  homepage: "/",
  login: "/login",
  signup: "/signup",
  profile: "/profile",
  upcoming_interviews: "/upcoming-interviews",
  application_timeline: "/application-timeline",
  job_search: "/job-search",
  all_jobs: "/jobs",
  recommended_jobs: "/recommended-jobs",
  saved_jobs: "/saved-jobs",
  request_demo: "/request-demo",
  recruitment_solutions: "/recruitment-solutions",
  branded_company_page: "/branded-company-page",
  request_portal: "/request-portal",
  manage_employees_info: "/manage-employees",
  support_services: "/support-services",
  interview_preparation: "/interview-preparation",
  resume_tips: "/resume-tips",
  community: "/community",
  test_application: "/test-app",
  test_instruction: "/test-instruction",
  job_description: "/job-desc",
  partner: "/partner",
  companies: "/companies/hiring",
  admin_dashboard: "/admin",
  hr_dashboard: "/hr",
  client_dashboard: "/clients",
  website_dashboard: "/website-builder",
  pingpong_dashboard: "/ping",
  notifications: "/notifications",
  settings: "/settings",
  about_us: "/about-us",
  checkout: "/checkout"
};